import { useEffect } from 'react';

const useKioskLockdown = () => {
    useEffect(() => {
        const handleContextMenu = (e) => e.preventDefault();

        const handleKeyDown = (e) => {
            // Alt+F4 / F4
            if (e.altKey && e.key === 'F4') { e.preventDefault(); return; }
            if (e.key === 'F4') { e.preventDefault(); return; }
            // Ctrl+W (cerrar pestaña)
            if (e.ctrlKey && (e.key === 'w' || e.key === 'W')) { e.preventDefault(); return; }
            // Ctrl+R / F5 (recargar)
            if (e.ctrlKey && (e.key === 'r' || e.key === 'R')) { e.preventDefault(); return; }
            if (e.key === 'F5') { e.preventDefault(); return; }
            // F12 / Ctrl+Shift+I (devtools)
            if (e.key === 'F12') { e.preventDefault(); return; }
            if (e.ctrlKey && e.shiftKey && (e.key === 'I' || e.key === 'i')) { e.preventDefault(); return; }
            // Ctrl+L (barra de direcciones)
            if (e.ctrlKey && (e.key === 'l' || e.key === 'L')) { e.preventDefault(); return; }
            // Ctrl+T / Ctrl+N (nueva pestaña/ventana)
            if (e.ctrlKey && (e.key === 't' || e.key === 'T')) { e.preventDefault(); return; }
            if (e.ctrlKey && (e.key === 'n' || e.key === 'N')) { e.preventDefault(); return; }
            // Ctrl++ / Ctrl+- / Ctrl+0 (zoom del navegador)
            if (e.ctrlKey && (e.key === '+' || e.key === '-' || e.key === '0' || e.key === '=')) { e.preventDefault(); return; }
        };

        // Bloquear zoom con Ctrl+scroll
        const handleWheel = (e) => {
            if (e.ctrlKey) e.preventDefault();
        };

        // Bloquear doble-tap zoom en touch
        let lastTouchEnd = 0;
        const handleTouchEnd = (e) => {
            const now = Date.now();
            if (now - lastTouchEnd <= 300) {
                e.preventDefault();
            }
            lastTouchEnd = now;
        };

        // --- Pantalla completa persistente (mitigación de kiosco) ---
        // El navegador SIEMPRE permite salir de fullscreen con ESC/gesto (no se puede
        // bloquear por JS). Mitigación: si sale SIN autorización (sin PIN), se vuelve a
        // entrar en el siguiente toque. La salida por PIN marca window.__kioskIntentionalExit.
        let needsRefs = true; // arranca queriendo entrar en la primera interacción
        const isFs = () => !!(document.fullscreenElement || document.webkitFullscreenElement);
        const goFs = () => {
            try {
                const el = document.documentElement;
                const fn = el.requestFullscreen || el.webkitRequestFullscreen || el.mozRequestFullScreen || el.msRequestFullscreen;
                if (fn && !isFs()) fn.call(el);
            } catch (e) { /* ignore */ }
        };
        const onPointerFs = () => { if (needsRefs && !isFs()) goFs(); };
        const onFsChange = () => {
            if (isFs()) { needsRefs = false; return; }
            if (window.__kioskIntentionalExit) { window.__kioskIntentionalExit = false; needsRefs = false; } // salida por PIN
            else { needsRefs = true; } // salió por ESC/gesto → re-entrar al próximo toque
        };

        document.addEventListener('contextmenu', handleContextMenu);
        document.addEventListener('keydown', handleKeyDown);
        document.addEventListener('wheel', handleWheel, { passive: false });
        document.addEventListener('touchend', handleTouchEnd, { passive: false });
        document.addEventListener('pointerdown', onPointerFs, true);
        document.addEventListener('fullscreenchange', onFsChange);
        document.addEventListener('webkitfullscreenchange', onFsChange);

        return () => {
            document.removeEventListener('contextmenu', handleContextMenu);
            document.removeEventListener('keydown', handleKeyDown);
            document.removeEventListener('wheel', handleWheel);
            document.removeEventListener('touchend', handleTouchEnd);
            document.removeEventListener('pointerdown', onPointerFs, true);
            document.removeEventListener('fullscreenchange', onFsChange);
            document.removeEventListener('webkitfullscreenchange', onFsChange);
        };
    }, []);
};

export default useKioskLockdown;
